import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

export const Layout = forwardRef<HTMLDivElement, React.ComponentProps<"div">>(
  ({ children, className, ...props }, ref) => (
    <div
      ref={ref}
      data-slot="layout"
      className={twMerge(
        "flex flex-col antialiased overscroll-none",
        "[--nav-height:--spacing(14)]",
        "has-data-[slot=layout-subheader]:[--subheader-height:--spacing(14)]",
        "has-data-[slot=layout-footer]:[--footer-height:--spacing(14)]",
        "pb-(--footer-height,0px)",
        "-mx-10 -mb-12 sm:-mx-12 lg:-mx-14",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  ),
);
Layout.displayName = "Layout";

export const LayoutSubheader = forwardRef<HTMLDivElement, React.ComponentProps<"div">>(
  ({ children, className, ...props }, ref) => (
    <div
      ref={ref}
      data-slot="layout-subheader"
      className={twMerge("sticky z-30", "top-(--nav-height,0px) h-(--subheader-height)", className)}
      {...props}
    >
      {children}
    </div>
  ),
);
LayoutSubheader.displayName = "LayoutSubheader";

export const LayoutBody = forwardRef<HTMLDivElement, React.ComponentProps<"div">>(
  ({ children, className, ...props }, ref) => (
    <div ref={ref} className={twMerge("flex gap-8 px-14", className)} {...props}>
      {children}
    </div>
  ),
);
LayoutBody.displayName = "LayoutBody";

export const LayoutMain = forwardRef<HTMLElement, React.ComponentProps<"main">>(
  ({ children, className, ...props }, ref) => (
    <main ref={ref} data-slot="layout-main" className={twMerge("flex-3 min-w-0 ", className)} {...props}>
      {children}
    </main>
  ),
);
LayoutMain.displayName = "LayoutMain";

export const LayoutAside = forwardRef<HTMLElement, React.ComponentProps<"aside">>(
  ({ children, className, ...props }, ref) => (
    <aside
      ref={ref}
      data-slot="layout-aside"
      className={twMerge(
        "flex-1 overflow-y-auto overscroll-contain",
        "sticky top-[calc(var(--nav-height,0px)+var(--subheader-height,0px))]",
        "h-[calc(100vh-var(--nav-height,0px)-var(--subheader-height,0px)-var(--footer-height,0px))]",
        className,
      )}
      {...props}
    >
      {children}
    </aside>
  ),
);
LayoutAside.displayName = "LayoutAside";

export const LayoutFooter = forwardRef<HTMLElement, React.ComponentProps<"footer">>(
  ({ children, className, ...props }, ref) => (
    <footer
      ref={ref}
      data-slot="layout-footer"
      className={twMerge(
        "fixed inset-x-0 bottom-0 z-50 flex items-center justify-end bg-white border-t border-limestone-200",
        "h-(--footer-height) px-6",
        className,
      )}
      {...props}
    >
      {children}
    </footer>
  ),
);
LayoutFooter.displayName = "LayoutFooter";
